class MinicartGTMEvents {
    constructor() {
        this.currency = ShopifyAnalytics?.meta?.currency || null;

        this.bindEvents();
    }

    init() {
        document.querySelectorAll('.vlisco-cart-item__button--remove').forEach(btn => {
            if (!btn.dataset.gtmBound) {
                btn.addEventListener('click', this.removeFromCart.bind(this));
                btn.dataset.gtmBound = "true";
            }
        });

        document.querySelectorAll('.vlisco-cart-item__button--plus, .vlisco-cart-item__button--minus').forEach(btn => {
            if (!btn.dataset.gtmBound) {
                btn.addEventListener('click', this.updateAddToCart.bind(this));
                btn.dataset.gtmBound = "true";
            }
        });

        document.querySelectorAll('.vlisco-cart__trigger-open').forEach(btn => {
            if (!btn.dataset.gtmBound) {
                btn.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.viewCart();
                });
                btn.dataset.gtmBound = "true";
            }
        });
    }

    bindEvents() {
        this.init()

        document.addEventListener('gtm:initialize-minicart', () => this.init());
    }

    getCartItemContainer(target) {
        if (!target || target.nodeType !== 1) return null;
        return target.closest('.vlisco-cart-item');
    }

    getPriceFromElement(cartItem, selector) {
        const el = cartItem.querySelector(selector);
        if (!el) return 0;
        const priceText = el.textContent.trim();
        const match = priceText.match(/\d+([.,]\d+)?/);
        return match ? Number(match[0].replace(',', '.')) : 0;
    }

    getBaseItemData(cartItem) {
        const sku = cartItem.getAttribute('data-sku') || '';
        const baseSku = sku.split('.').slice(0, 2).join('.');
        return {
            item_name: baseSku,
            item_id: baseSku,
            item_category: cartItem.getAttribute('data-category'),
            item_variant: sku,
            id: cartItem.getAttribute('data-id'),
        };
    }

    getPriceData(cartItem) {
        return {
            price: this.getPriceFromElement(cartItem, '.vlisco-card-item-price div:first-child'),
            display_price: this.getPriceFromElement(cartItem, '.vlisco-card-item-price div:last-child'),
        };
    }

    buildItemObject(cartItem, quantity = 1, extraFields = {}) {
        return {
            ...this.getBaseItemData(cartItem),
            ...this.getPriceData(cartItem),
            display_price_currency: this.currency,
            quantity: Number(quantity),
            ...extraFields,
        };
    }

    pushEvent({ eventName, cartItem, quantity, extraFields = {} }) {
        const item = this.buildItemObject(cartItem, quantity, extraFields);
        const eventValue = item.display_price * item.quantity;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            event: eventName,
            ecommerce: {
                currency: this.currency,
                value: eventValue,
                items: [item],
            },
        });
    }

    updateAddToCart(event) {
        event.preventDefault();
        const cartItem = this.getCartItemContainer(event.currentTarget);
        if (!cartItem) return;

        if (event.currentTarget.classList.contains('vlisco-cart-item__button--plus')) {
            this.pushEvent({
                eventName: 'add_to_cart',
                cartItem,
                quantity: 1,
                extraFields: {
                    item_list_name: "Category Overview",
                    item_list_id: "category",
                },
            });
        } else if (event.currentTarget.classList.contains('vlisco-cart-item__button--minus')) {
            this.pushEvent({
                eventName: 'remove_from_cart',
                cartItem,
                quantity: 1
            });
        }
    }

    removeFromCart(event) {
        const cartItem = this.getCartItemContainer(event.target);
        if (!cartItem) return;

        const quantityInput = cartItem.querySelector('input.vlisco-cart-item__input');
        const quantity = quantityInput ? Number(quantityInput.value) : 1;

        this.pushEvent({
            eventName: 'remove_from_cart',
            cartItem,
            quantity
        });
    }

    viewCart() {
        const cartProducts = document.querySelectorAll('.vlisco-cart-item');
        const items = Array.from(cartProducts).map(product => {
            const quantityInput = product.querySelector('input.vlisco-cart-item__input');
            const quantity = quantityInput ? Number(quantityInput.value) : 1;
            return this.buildItemObject(product, quantity);
        });

        const totalValue = items.reduce((sum, item) => sum + item.price * item.quantity, 0);

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            event: 'view_cart',
            ecommerce: {
                currency: this.currency,
                value: totalValue,
                items,
            },
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new MinicartGTMEvents();
});
